/* @generated */

// ../src/modal/modal.tsx
import classNames7 from "classnames";
import * as React8 from "react";
import ReactModal from "react-modal";
import { MODAL_BASE_INDEX, LayerContext } from "@dropbox/dig-components/layer";
import { useTheme } from "@dropbox/dig-foundations";
import { IconButton } from "@dropbox/dig-components/buttons";
import { UIIcon } from "@dropbox/dig-icons";
import { CloseLine } from "@dropbox/dig-icons/assets";

// ../src/modal/content.tsx
import * as React from "react";
import classNames from "classnames";

// ../src/modal/modal.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var isCenteredSelector = "dig-5lbgm34_22-5-0";
var isFullScreenSelector = "dig-5lbgm35_22-5-0";
var modalBodyFocusStyles = "dig-5lbgm3v_22-5-0";
var modalBodyRecipe = _7a468({ defaultClassName: "dig-5lbgm3l_22-5-0", variantClassNames: { hasVerticalSpacing: { true: "dig-5lbgm3m_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var modalCloseButtonStyle = "dig-5lbgm3u_22-5-0";
var modalContent = "dig-5lbgm3c_22-5-0";
var modalContentBorderRadiusRecipe = _7a468({ defaultClassName: "dig-5lbgm3g_22-5-0", variantClassNames: { isFullScreen: { true: "dig-5lbgm3h_22-5-0", false: "dig-5lbgm3i_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var modalContentStyle = "dig-5lbgm3o_22-5-0";
var modalContentTransformPositioningRecipe = _7a468({ defaultClassName: "dig-5lbgm3d_22-5-0", variantClassNames: { isCentered: { true: "dig-5lbgm3e_22-5-0" }, fullScreen: { true: "dig-5lbgm3f_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var modalFooterRecipe = _7a468({ defaultClassName: "dig-5lbgm3q_22-5-0", variantClassNames: { preferComposition: { true: "dig-5lbgm3r_22-5-0", false: "dig-5lbgm3s_22-5-0" }, hasTopBorder: { true: "dig-5lbgm3t_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var modalFullWidthStyle = "dig-5lbgm3n_22-5-0";
var modalHeaderRecipe = _7a468({ defaultClassName: "dig-5lbgm3j_22-5-0", variantClassNames: { marginTitleStandard: { true: "dig-5lbgm3k_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var modalHtmlStyle = "dig-5lbgm3w_22-5-0";
var modalOverlayGridRecipe = _7a468({ defaultClassName: "dig-5lbgm36_22-5-0", variantClassNames: { isVerticallyCentered: { true: "dig-5lbgm37_22-5-0", false: "dig-5lbgm38_22-5-0" }, isFullScreen: { true: "dig-5lbgm39_22-5-0", false: "dig-5lbgm3a_22-5-0" } }, defaultVariants: {}, compoundVariants: [[{ isVerticallyCentered: false, isFullScreen: false }, "dig-5lbgm3b_22-5-0"]] });
var modalOverlayStyle = "dig-5lbgm33_22-5-0";
var modalTitleStyle = "dig-5lbgm3p_22-5-0";

// ../src/modal/content.tsx
var Content = ({ children, className, ...rest }) => /* @__PURE__ */ React.createElement("div", { className: classNames("dig-Modal-content", modalContentStyle, className), ...rest }, children);

// ../src/modal/header.tsx
import * as React2 from "react";
import classNames2 from "classnames";
var Header = ({
  hasBottomSpacing = "title-small",
  children,
  className = "",
  ...rest
}) => {
  const cls = classNames2(
    "dig-Modal-header",
    modalHeaderRecipe({ marginTitleStandard: hasBottomSpacing === "title-standard" }),
    {
      "dig-Modal-header--margin-title-standard": hasBottomSpacing === "title-standard"
    },
    className
  );
  return /* @__PURE__ */ React2.createElement("div", { className: cls, ...rest }, children);
};
Header.displayName = "Header";

// ../src/modal/body.tsx
import * as React4 from "react";
import classNames3 from "classnames";
import { makeScrollbarClassName } from "@dropbox/dig-foundations";

// ../src/modal/context.ts
import * as React3 from "react";
var defaultValue = {
  isFullScreen: false
};
var ModalContext = React3.createContext(defaultValue);
ModalContext.displayName = "ModalContext";

// ../src/modal/body.tsx
var Body = React4.forwardRef(
  ({ children, className = "", hasVerticalSpacing = false, ...rest }, ref) => {
    const { isFullScreen } = React4.useContext(ModalContext);
    const cls = classNames3(
      "dig-Modal-body",
      modalBodyRecipe({ hasVerticalSpacing }),
      modalBodyFocusStyles,
      className,
      makeScrollbarClassName({
        // Use None for the border radius because in full screen there is no corner rounding
        borderRadius: isFullScreen ? "None" : "XLarge"
      }),
      {
        "dig-Modal-body--hasVerticalSpacing": hasVerticalSpacing
      }
    );
    return /* @__PURE__ */ React4.createElement("div", { ref, className: cls, ...rest }, children);
  }
);
Body.displayName = "Body";

// ../src/modal/footer.tsx
import * as React5 from "react";
import classNames4 from "classnames";
var Footer = ({
  hasTopBorder = false,
  children,
  className = "",
  preferComposition = false,
  ...rest
}) => {
  const cls = classNames4(
    {
      "dig-Modal-footer": !preferComposition,
      "dig-Modal-prefer-composition-footer": preferComposition,
      "dig-Modal-footer--hasTopBorder": hasTopBorder
    },
    modalFooterRecipe({ preferComposition, hasTopBorder }),
    className
  );
  return /* @__PURE__ */ React5.createElement("div", { className: cls, ...rest }, children);
};
Footer.displayName = "Footer";

// ../src/modal/title.tsx
import * as React6 from "react";
import classNames5 from "classnames";
import {
  Title as TypographyTitle
} from "@dropbox/dig-components/typography";
var Title = ({ children, className = "", ...rest }) => {
  const cls = classNames5("dig-Modal-title", modalTitleStyle, className);
  return /* @__PURE__ */ React6.createElement(TypographyTitle, { className: cls, ...rest }, children);
};
Title.displayName = "Title";

// ../src/modal/full_bleed.tsx
import * as React7 from "react";
import classNames6 from "classnames";
var FullBleed = ({
  children,
  className,
  ...rest
}) => {
  const cls = classNames6("dig-Modal-full-width", modalFullWidthStyle, className);
  return /* @__PURE__ */ React7.createElement("div", { className: cls, ...rest }, children);
};

// ../../design-tokens/dist/dig/index.js
var BreakpointXSmall = "0";
var BreakpointSmall = "600";
var BreakpointMedium = "1024";
var BreakpointLarge = "1600";
var BreakpointXLarge = "1920";

// ../src/_global/breakpoints.ts
var breakpoints = {
  xsmall: parseInt(BreakpointXSmall, 10),
  small: parseInt(BreakpointSmall, 10),
  medium: parseInt(BreakpointMedium, 10),
  large: parseInt(BreakpointLarge, 10),
  xlarge: parseInt(BreakpointXLarge, 10)
};

// ../src/_global/queryMatchMedia.ts
var queries = /* @__PURE__ */ new Map();
function createMediaQueryEntry(query) {
  const list = window.matchMedia(query);
  const listeners = /* @__PURE__ */ new Set();
  const dispatch = ({ matches }) => {
    listeners.forEach((listener) => listener(matches));
  };
  const entry = {
    list,
    listeners,
    dispatch
  };
  list.addEventListener("change", dispatch, { passive: true });
  return entry;
}
function teardownMediaQueryEntry(queryEntry) {
  const { list, dispatch, listeners } = queryEntry;
  list.removeEventListener("change", dispatch);
  listeners.clear();
}
function setupMediaQuery(query, listener) {
  if (!queries.has(query)) {
    const queryEntry2 = createMediaQueryEntry(query);
    queries.set(query, queryEntry2);
  }
  const queryEntry = queries.get(query);
  const hadListener = queryEntry.listeners.has(listener);
  queryEntry.listeners.add(listener);
  if (!hadListener) {
    listener(queryEntry.list.matches);
  }
}
function removeMediaQuery(query, listener) {
  if (!queries.has(query)) {
    return;
  }
  const queryEntry = queries.get(query);
  queryEntry.listeners.delete(listener);
  if (queryEntry.listeners.size === 0) {
    teardownMediaQueryEntry(queryEntry);
    queries.delete(query);
  }
}
function queryMatchMedia({
  query,
  listener,
  defaultValue: defaultValue2
}) {
  if (!("window" in globalThis && "matchMedia" in window)) {
    listener(defaultValue2);
    return () => {
    };
  }
  setupMediaQuery(query, listener);
  return () => {
    removeMediaQuery(query, listener);
  };
}

// ../src/modal/modal.tsx
var getWidthPx = (width) => {
  switch (width) {
    case "small":
      return 450;
    /**
     * When updating this breakpoint, it must be updated within
     * the CSS and the useSmallMediaQuery as well because it drives the custom scrollbar styles
     */
    case "standard":
      return 600;
    case "large":
      return 700;
  }
  return width;
};
function useSmallMediaQuery() {
  const [matches, setMatches] = React8.useState(false);
  React8.useEffect(() => {
    const cleanupQuery = queryMatchMedia({
      query: `(max-width: ${breakpoints.small}px)`,
      listener: setMatches,
      defaultValue: false
    });
    return cleanupQuery;
  }, [setMatches]);
  return matches;
}
var Modal = React8.forwardRef(
  ({
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedby,
    children,
    className,
    fullScreen = false,
    isCentered = false,
    withCloseButton,
    width = "standard",
    open = false,
    shouldCloseOnOverlayClick = true,
    shouldFocusAfterRender = true,
    onRequestClose,
    onAfterOpen,
    onAfterClose,
    overlayClassName,
    modalBaseIndex = MODAL_BASE_INDEX,
    parentSelector: parentSelectorProp,
    hasAutoFocusClose = false,
    closeButtonProps,
    overlayStyles,
    contentStyles,
    contentOverflow = "visible",
    data,
    positioningStrategy = "transform",
    ...rest
  }, ref) => {
    const contentRef = React8.useRef();
    const { portalRootElement: contextRootElement } = React8.useContext(LayerContext) || {};
    const parentSelector = typeof parentSelectorProp === "function" ? parentSelectorProp : contextRootElement ? () => contextRootElement : void 0;
    const { getThemeProps } = useTheme();
    const cls = classNames7(
      "dig-Modal",
      modalContent,
      modalContentBorderRadiusRecipe({ isFullScreen: fullScreen }),
      {
        "dig-Modal--isCentered": isCentered,
        [isCenteredSelector]: isCentered,
        "dig-Modal--fullScreen": fullScreen,
        [isFullScreenSelector]: fullScreen
      },
      {
        [modalContentTransformPositioningRecipe({
          isCentered,
          fullScreen
        })]: positioningStrategy === "transform"
      },
      className
    );
    const attachContentRef = React8.useCallback((instance) => {
      contentRef.current = instance;
    }, []);
    const onClickClose = onRequestClose;
    const focus = React8.useCallback(() => {
      if (contentRef && contentRef.current) {
        contentRef.current.focus();
      }
    }, [contentRef]);
    React8.useImperativeHandle(ref, () => ({ focus }), [focus]);
    const isSmallBreakpoint = useSmallMediaQuery();
    const ariaProp = React8.useMemo(() => {
      if (ariaLabelledby === void 0) {
        return void 0;
      }
      return {
        labelledby: ariaLabelledby,
        describedby: ariaDescribedby
      };
    }, [ariaLabelledby, ariaDescribedby]);
    return /* @__PURE__ */ React8.createElement(
      ReactModal,
      {
        ...rest,
        data,
        testId: rest.testId || rest["data-testid"],
        aria: ariaProp,
        contentLabel: ariaLabel,
        contentRef: attachContentRef,
        isOpen: open,
        shouldCloseOnOverlayClick,
        shouldFocusAfterRender,
        onRequestClose,
        onAfterOpen,
        onAfterClose,
        className: cls,
        bodyOpenClassName: classNames7("dig-Modal-body--open", modalHtmlStyle),
        htmlOpenClassName: classNames7("dig-Modal-html--open", modalHtmlStyle),
        overlayClassName: classNames7(
          "dig-Modal-overlay",
          overlayClassName,
          modalOverlayStyle,
          {
            [modalOverlayGridRecipe({
              isVerticallyCentered: isCentered,
              isFullScreen: fullScreen
            })]: positioningStrategy === "grid"
          },
          // We add the theme class names to the root-most container of `Modal`
          getThemeProps().className
        ),
        parentSelector,
        closeTimeoutMS: 200,
        style: {
          overlay: {
            ...overlayStyles,
            // `react-modal` by default portals into the `document.body` and isn't connected to
            // our elevation system. To address this, we need to apply a z-index to the
            // internal overlay rendered by `react-modal` so if there's any elevated
            // components (Menu, Tooltips, etc.) that is rendered within this sub-layer, it will
            // be properly laid at a higher z-index.
            zIndex: modalBaseIndex
          },
          content: {
            ...contentStyles,
            width: fullScreen ? "100%" : getWidthPx(width)
          }
        }
      },
      /* @__PURE__ */ React8.createElement(LayerContext.Provider, { value: { zIndex: modalBaseIndex } }, /* @__PURE__ */ React8.createElement(ModalContext.Provider, { value: { isFullScreen: isSmallBreakpoint ? true : fullScreen } }, /* @__PURE__ */ React8.createElement(Content, { style: { overflow: contentOverflow === "hidden" ? "hidden" : void 0 } }, children)), !!withCloseButton && /* @__PURE__ */ React8.createElement(
        IconButton,
        {
          variant: "transparent",
          "aria-label": withCloseButton,
          "data-testid": "digModalCloseButton",
          autoFocus: hasAutoFocusClose,
          ...closeButtonProps,
          className: classNames7(
            "dig-Modal-close-btn",
            modalCloseButtonStyle,
            closeButtonProps == null ? void 0 : closeButtonProps.className
          ),
          onClick: (e) => {
            var _a;
            onClickClose == null ? void 0 : onClickClose(e);
            (_a = closeButtonProps == null ? void 0 : closeButtonProps.onClick) == null ? void 0 : _a.call(closeButtonProps, e);
          }
        },
        /* @__PURE__ */ React8.createElement(UIIcon, { src: CloseLine })
      ))
    );
  }
  // Type assertion to enable adding subcomponents as static props below
  // There doesn't seem to be a way to avoid this with current forwardRef typings
  // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757
);
Modal.Content = Content;
Modal.Header = Header;
Modal.Body = Body;
Modal.Footer = Footer;
Modal.Title = Title;
Modal.FullBleed = FullBleed;
Modal.displayName = "Modal";
var setAppElement = (appElement) => {
  ReactModal.setAppElement(appElement);
};
Modal.setAppElement = setAppElement;
export {
  Modal
};
